export default __webpack_public_path__ + "static/media/observing-user-experiences.75f3709d.svg";